var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goods-content"},_vm._l((_vm.orderTypes),function(order){return _c('div',{key:order.id,staticClass:"boxcontent-item",on:{"click":function($event){return _vm.$emit('on-open-form', order.modal)}}},[_c('i',{staticClass:"fas fa-door-closed"}),_c('p',{staticClass:"boxcontent-item-title"},[_vm._v(_vm._s(order.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }